<mat-card class="mat-page-card">
  <mat-card-title class="page-admin-sign-in-title">Administrator Sign&dash;In</mat-card-title>
  <mat-card-content class="mat-elevation-z0">
    <div>
      <form [formGroup]="form" (ngSubmit)="submit()">
        <p class="page-admin-sign-in-form-field">
          <mat-form-field>
            <mat-label>Email Address</mat-label>
            <input matInput placeholder="Email Address" formControlName="emailAddress">
            @if (form.controls['emailAddress'].invalid) {
              <mat-error color="red">
                @if (form.controls['emailAddress'].hasError('required')) {
                  You must enter your email address for authentication.
                } @else if (form.controls['emailAddress'].hasError('email')) {
                  Please ensure your email address is valid.
                } @else {
                  An unknown error occurred while validating your email address.
                }
              </mat-error>
            }
          </mat-form-field>
        </p>
        <p class="page-admin-sign-in-form-field">
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input matInput placeholder="Password" formControlName="password" type="password">
            @if (form.controls['password'].invalid) {
              <mat-error color="red">
                @if (form.controls['password'].hasError('required')) {
                  You must enter your password for authentication.
                } @else {
                  An unknown error occurred while validating your password.
                }
              </mat-error>
            }
          </mat-form-field>
        </p>

        <!-- Define our error container -->
        <mat-error *ngIf="errorMessage" class="page-admin-sign-in-error">{{ errorMessage }}</mat-error>

        <!-- Define our form actions container -->
        <div class="page-admin-sign-in-actions">
          <!-- Define our persistence toggle -->
          <span class="page-admin-sign-in-persistence">
            <mat-slide-toggle color="primary" formControlName="persistent">Remember Me</mat-slide-toggle>
          </span>

          <!-- Define our submit button container -->
          <span class="page-admin-sign-in-button">
            <button mat-raised-button color="accent" type="submit">Sign&dash;In</button>
          </span>
        </div>
      </form>
    </div>
  </mat-card-content>
</mat-card>
